import React from "react";
import classNames from "classnames";
import AsyncSelect, { AsyncProps } from "react-select/async";
import { components } from "react-select";
import { useCopies } from "shared/hooks/useCopies";
import { GroupBase } from "react-select";
import { ReactSelectMenuPosition } from "shared/enums/ReactSelectMenuPlacement";

/**
 * Use this select component when need to load option from async apis
 */
function AsyncSelectDropdown<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>({ cacheOptions = true, ...props }: AsyncProps<Option, IsMulti, Group>, ref: React.Ref<any>) {
  const copies = useCopies();
  const containerRef = React.useRef(null);
  return (
    <div
      ref={containerRef}
      className={classNames("selectDropdown_wrapper", {
        "selectDropdown_wrapper--isMulti": props.isMulti,
        "selectDropdown_wrapper--is-disabled": props.isDisabled
      })}>
      <AsyncSelect
        name={props.name}
        inputId={props.name}
        ref={ref}
        className={classNames(props.className, "selectDropdown", {
          "selectDropdown--isMulti": props.isMulti,
          "selectDropdown--isClearable": props.isClearable
        })}
        classNamePrefix={"selectDropdown"}
        placeholder={copies.get("type.to.search")}
        defaultOptions={props.defaultOptions}
        value={props.value}
        isMulti={props.isMulti}
        cacheOptions={cacheOptions}
        isDisabled={props.isDisabled}
        onChange={props.onChange}
        loadOptions={props.loadOptions}
        menuPortalTarget={document.body}
        menuPosition={"fixed"}
        menuPlacement={ReactSelectMenuPosition.AUTO}
        closeMenuOnScroll={(e: any) => {
          return e.target.contains(containerRef.current);
        }}
        loadingMessage={() => {
          return copies.get("loading.options");
        }}
        noOptionsMessage={() => {
          return null;
        }}
        {...props}
        components={{
          Menu: CustomMenu,
          LoadingIndicator: undefined,
          ...props.components
        }}
      />
    </div>
  );
}

export default React.forwardRef(AsyncSelectDropdown);

function CustomMenu(props: any) {
  //Passing key to ensure menu placement is re-calculated on option load
  return (
    <components.Menu key={"asyncSelectOptions" + props.isLoading} {...props}>
      {props.children}
    </components.Menu>
  );
}
